import React, {FC} from 'react';
import '../TastesTobacco/style.scss';
import {hardness} from '../../assets/data/hardnessData';
import BaseButton from "../form/Button";

interface IHardnessList {
    setActiveHardness: any,
    activeHardnessId: number,
}

const HardnessList: FC<IHardnessList> = ({setActiveHardness, activeHardnessId}) => {
    return (
        <div className="tastes__list">
            {
                hardness.map((el: any) => {
                    return (
                        <BaseButton
                            key={el.id}
                            isPreferenceButton
                            isActive={el.id === activeHardnessId}
                            onClick={() => setActiveHardness(el.id)}
                        >
                            {el.name}
                        </BaseButton>
                    );
                })
            }
        </div>
    );
};

export default HardnessList;
